<template>
  <transition name="slide-fade" mode="out-in">
    <div v-if="saldo" class="headline">
      saldo:
      <transition name="slide-fade" mode="out-in">
        <span :key="saldo.credit">{{
          saldo.credit | formattedSaldo
        }}</span> </transition
      >&nbsp;kr
    </div>
  </transition>
</template>

<script>
export default {
  props: ["saldo"],
  filters: {
    formattedSaldo: function(credit) {
      const formatted = Number(credit);
      return (
        (formatted &&
          formatted.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })) ||
        "0"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
